export default __webpack_public_path__ + "static/media/example_3.51fc5d82.png";